import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardHeader, CircularProgress, useTheme } from '@material-ui/core';
import { getDiasSemanaMaisFiliadoAtivos } from '../../../../../services/DashboardService';
import Chart from 'react-apexcharts';
import Grid from '@material-ui/core/Grid';


const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 20,
    minHeight: 400
  },
  chartContainer: {
    minHeight: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const GraficoDiasSemanaMaisFiliadosAtivos = props => {
  const { className, ...rest } = props;
  const theme = useTheme();
  const [mostrarProgress, setMostrarProgress] = useState(true);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);
  const [labelsFiliados, setLabelsFiliados] = useState([]);
  const [quantidadesFiliados, setQuantidadesFiliados] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    try {
      getDadosFiliados();
    }
    catch (e) {

    }
  }, []);

  async function getDadosFiliados() {
    try {
      setMostrarProgress(true);
      let dadosFiliados = await getDiasSemanaMaisFiliadoAtivos();
      if (dadosFiliados.isSuccess) {
        setMostrarProgress(false);
        let novasLabelsFiliados = [];
        let novasQuantidadesFiliados = [];
        dadosFiliados.result.map(diaSemana => {
          novasLabelsFiliados.push([diaSemana.nomeDiaSemana]);
          novasQuantidadesFiliados.push(diaSemana.valorTotalDiaSemana);
        });
        setLabelsFiliados(novasLabelsFiliados);
        setQuantidadesFiliados(novasQuantidadesFiliados);
      } else {
        setMostrarProgress(false);
      }
    } catch (e) {
      setMostrarProgress(false);
    }
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      elevation={3}
    >
      <CardHeader
        title="Dias da semana com maior presença de filiados ativos"
      />
      <CardContent
      >
        <Grid
          container
        >
          {
            mostrarProgress &&
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'center',
                height: 400
              }}
            >
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  height: 400,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <div className={classes.chartContainer}>
                  <CircularProgress
                  />
                </div>
              </Grid>
            </Grid>
          }
          {
            !mostrarProgress &&
            <Grid
              item
              md={12}
              xs={12}

            >
              <div className={classes.chartContainer}>
                <Chart
                  options={{
                    chart: {
                      id: 'graficoDiasSemanaMaisFiliadosAtivos',
                      type: 'area',
                      height: 350,
                      toolbar: {
                        show: false
                      },
                    },
                    dataLabels: {
                      enabled: false
                    },
                    markers: {
                      size: 6,
                    },
                    colors: [theme.palette.info.main],
                    fill: {
                      colors: [theme.palette.info.main]
                    },
                    yaxis: {
                      labels: {
                        formatter: function (val) {
                          return val;
                        },
                      },
                      title: {
                        text: 'Quantidade'
                      },
                    },
                    xaxis: {
                      type: 'category',
                      categories: labelsFiliados,
                    },
                    tooltip: {
                      shared: true,
                      y: {
                        show: true,
                        formatter: function (val) {
                          return val
                        }
                      },
                      x: {
                        show: true,
                        formatter: function(val) {
                          return val
                        }
                      }
                    },

                  }}
                  type={'area'}
                  series={[{
                    name: 'Quantidade',
                    data: quantidadesFiliados
                  }]}
                  height={400}
                />
              </div>
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

GraficoDiasSemanaMaisFiliadosAtivos.propTypes = {
  className: PropTypes.string
};

export default GraficoDiasSemanaMaisFiliadosAtivos;
